import { render, staticRenderFns } from "./picUpload.vue?vue&type=template&id=3800ac99&scoped=true&lang=html"
import script from "./picUpload.vue?vue&type=script&lang=js"
export * from "./picUpload.vue?vue&type=script&lang=js"
import style0 from "./picUpload.vue?vue&type=style&index=0&id=3800ac99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800ac99",
  null
  
)

export default component.exports